/**
 * Persist last game selected in Explore (logged-in users only).
 * Web: localStorage. Native: Capacitor Preferences (aligned with auth storage split).
 */
import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";

const STORAGE_KEY = "pista_explore_last_game_v1";

function parseStored(raw) {
  if (!raw) return null;
  try {
    const o = JSON.parse(raw);
    if (!o || typeof o !== "object" || !o.game) return null;
    return o;
  } catch {
    return null;
  }
}

export async function readLastExploreGame(userId) {
  if (!userId) return null;
  try {
    let raw = null;
    if (Capacitor.isNativePlatform()) {
      const { value } = await Preferences.get({ key: STORAGE_KEY });
      raw = value;
    } else {
      raw = localStorage.getItem(STORAGE_KEY);
    }
    const parsed = parseStored(raw);
    if (!parsed || Number(parsed.userId) !== Number(userId)) return null;
    return parsed.game;
  } catch {
    return null;
  }
}

export async function writeLastExploreGame(userId, game) {
  if (!userId || !game) return;
  const id = game.id ?? game.game_id;
  if (id === null || id === undefined) return;
  const payload = JSON.stringify({
    userId: Number(userId),
    game: {
      id,
      game_id: id,
      name: game.name ?? game.game_name,
      game_name: game.game_name ?? game.name,
      year_published: game.year_published,
      thumbnail: game.thumbnail,
      average_rating: game.average_rating,
      num_ratings: game.num_ratings,
      features: game.features || [],
    },
  });
  if (Capacitor.isNativePlatform()) {
    await Preferences.set({ key: STORAGE_KEY, value: payload });
  } else {
    localStorage.setItem(STORAGE_KEY, payload);
  }
}
